import { Output, EventEmitter, ViewChild, } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { ValidationService } from 'src/app/common/services/validation.service';
import { constObj } from '../../Constants/constants';
import { MatSelect } from '@angular/material/select';


@Component({
  selector: 'app-general-feedback',
  templateUrl: './general-feedback.component.html',
  styleUrls: ['./general-feedback.component.css']
})
export class GeneralFeedbackComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  loadpagecontent: boolean = false;
  globalcancel: string;
  generalFeedbacklink: string;
  generalFeedbacktext: string;
  providefeedback: string;
  yourfeedback: string;
  globalsubmit: string;
  typeoffeedback: string;
  feedbackTypeList: string[];
  param: {};
  textareaError: string = "";
  usernameError;
  usernameInput: any;
  feedbackvalidationError: string;
  feedbackEmailbody: string;
  feedbackEmailsubject: string;
  emailsubjectcodtech: string;
  emailbodycodtech: string;

  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private _validationService: ValidationService,
  ) { }

  currentParagraph: string;
  navData = {
    crumbData: [],
  };


  feedBackForm = new FormGroup({
    feedBackType: new FormControl(''),
    feedBackContent: new FormControl(''),
  })

  @ViewChild("feedBackTypeSelect", { static: false }) nameField: MatSelect;

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getProfessionalContent();
    this.getgeneralFeedbackDropdownValues();
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.feedBackForm.controls[controlName].hasError(errorName);
  }

  getProfessionalContent() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != null) {
        this.loadpagecontent = true;
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.providefeedback = labels.filter(x => x.key == "generalFeedback_title").map(y => y.value);
        this.typeoffeedback = labels.filter(x => x.key == "provideFeedback_title").map(y => y.value);
        this.globalcancel = labels.filter(x => x.key == "global_cancel").map(y => y.value);
        this.globalsubmit = labels.filter(x => x.key == "global_submit").map(y => y.value);
        this.yourfeedback = labels.filter(x => x.key == "provideFeedback_body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
      else {
        //TODO : check the negative scenario
        this.commonDataService.showLoader.next(false);
      }
    });
  }

  getgeneralFeedbackDropdownValues() {
    this.graphQlService.getgeneralFeedbackDropdown().subscribe(data => {
      if (data != null) {
        this.loadpagecontent = true;
        this.feedbackTypeList = data.content?.data?.listItem;
        this.commonDataService.showLoader.next(false);
      }
    });
  }



  remainingText: number = 0;
  feedbackDescriptionChange(value: string) {
    this.remainingText = 4000 - value.length;
  }

  closeOverlay() {
    this.myEvent.emit();
    this.commonDataService.showLoader.next(false);
  }
  checkHome() {
  }

  checkfeedBackType() {
    let isValid = true;
    if (!this._validationService.validateRequiredField(this.feedBackForm.controls.feedBackType.value)) {
      this.feedBackForm.controls.feedBackType.setErrors({ 'isEmpty': true });
      this.feedbackvalidationError = this._validationService.getErrorMessage('required', this.typeoffeedback, null);
      this.feedBackForm.controls.feedBackType.markAsTouched();
      isValid = false
    }


    if (isValid) {
      this.feedBackForm.controls.feedBackType.setErrors(null);
      this.feedbackvalidationError = '';
    }

    return isValid;
  }

  checkfeedBackContent() {
    let isfeedBackContentValid = true;
    if (!this._validationService.validateRequiredField(this.feedBackForm.controls.feedBackContent.value) || this.feedBackForm.controls.feedBackContent.value.trim() == "") {
      this.feedBackForm.controls.feedBackContent.setErrors({ 'isEmpty': true });
      this.feedbackvalidationError = this._validationService.getErrorMessage('required', this.yourfeedback, null);
      this.feedBackForm.controls.feedBackContent.markAsTouched();
      isfeedBackContentValid = false
    }


    if (isfeedBackContentValid) {
      this.feedBackForm.controls.feedBackContent.setErrors(null);
      this.feedbackvalidationError = '';
    }

    return isfeedBackContentValid;
  }

  submittFeedback() {
    let checkfeedBackTypeValid = this.checkfeedBackType()
    if (checkfeedBackTypeValid) {
      let checkfeedBackContentValid = this.checkfeedBackContent();
      if (checkfeedBackContentValid) {
        //code for fetch email lables
        this.commonDataService.showLoader.next(true);
        this.graphQlService.getGlobalLabels().subscribe(data => {
          if (data != null) {
            this.loadpagecontent = true;
            //var labels = data.labels.content.data.labels
            var labels = data.content.data.labels
            labels = labels.filter(x => x.key.trim());
            this.feedbackEmailbody = labels.filter(x => x.key == "feedbackEmail_body").map(y => y.value);
            this.feedbackEmailsubject = labels.filter(x => x.key == "feedbackEmail_subject").map(y => y.value);
            this.emailsubjectcodtech = labels.filter(x => x.key == "codtechEmail_subject").map(y => y.value);
            this.emailbodycodtech = labels.filter(x => x.key == "codtechEmail_body").map(y => y.value);
            const body = {
              feedBackContent: this.feedBackForm.controls.feedBackContent.value,
              feedBackType: this.feedBackForm.controls.feedBackType.value,
              feedbackEmailbody: this.feedbackEmailbody[0],
              feedbackEmailsubject: this.feedbackEmailsubject[0],
              emailsubjectcodtech: this.emailsubjectcodtech[0],
              emailbodycodtech: this.emailbodycodtech[0]
            };
            this.graphQlService.sentmailgeneralFeedback(body).subscribe(data1 => {
              if (data1 != null) {
                let obj;
                if (data1.isEmailSent) {
                  obj = {
                    type: 'success',
                    displayTime: 5000,
                    position: 'bottom',
                    message: constObj.generalFeedbackSuccess
                  }
                }
                else {
                  obj = {
                    type: 'fail',
                    displayTime: 5000,
                    position: 'bottom',
                    message: constObj.generalFeedbacemailFail
                  }
                }
                this.commonDataService.notificationObject.next(obj);
                this.closeOverlay();
              }
              else {
                this.closeOverlay();
              }
            });
          }
        });
      }
    }
  }

}
